var $542f39aee29303c3$exports = {};
$542f39aee29303c3$exports = {
  "dateRange": args => `${args.startDate} \u{304B}\u{3089} ${args.endDate}`,
  "dateSelected": args => `${args.date} \u{3092}\u{9078}\u{629E}`,
  "finishRangeSelectionPrompt": `\u{30AF}\u{30EA}\u{30C3}\u{30AF}\u{3057}\u{3066}\u{65E5}\u{4ED8}\u{7BC4}\u{56F2}\u{306E}\u{9078}\u{629E}\u{3092}\u{7D42}\u{4E86}`,
  "maximumDate": `\u{6700}\u{7D42}\u{5229}\u{7528}\u{53EF}\u{80FD}\u{65E5}`,
  "minimumDate": `\u{6700}\u{521D}\u{306E}\u{5229}\u{7528}\u{53EF}\u{80FD}\u{65E5}`,
  "next": `\u{6B21}\u{3078}`,
  "previous": `\u{524D}\u{3078}`,
  "selectedDateDescription": args => `\u{9078}\u{629E}\u{3057}\u{305F}\u{65E5}\u{4ED8} : ${args.date}`,
  "selectedRangeDescription": args => `\u{9078}\u{629E}\u{7BC4}\u{56F2} : ${args.dateRange}`,
  "startRangeSelectionPrompt": `\u{30AF}\u{30EA}\u{30C3}\u{30AF}\u{3057}\u{3066}\u{65E5}\u{4ED8}\u{7BC4}\u{56F2}\u{306E}\u{9078}\u{629E}\u{3092}\u{958B}\u{59CB}`,
  "todayDate": args => `\u{672C}\u{65E5}\u{3001}${args.date}`,
  "todayDateSelected": args => `\u{672C}\u{65E5}\u{3001}${args.date} \u{3092}\u{9078}\u{629E}`
};
export { $542f39aee29303c3$exports as default };